import { CountryInfoModel, PaymentMethodInfoModel } from '@fh-client-interaction-frontends/fh-providers';
import { CpPlansProductInterface } from '../../../../interfaces/dto/client-portal/product/product-interface';

export class CpPlansProductModel implements CpPlansProductInterface{
  baseValue: number = -1;
  countryInfos: CountryInfoModel[] = new Array<CountryInfoModel>();
  currency: string = "";
  description: string = "";
  maxPersons: number = 0;
  name: string = "";
  paymentMethods: PaymentMethodInfoModel[] = new Array<PaymentMethodInfoModel>();
  productId: string = "";

  constructor(init?: Partial<CpPlansProductModel>) {
    Object.assign(this, init);
  }
}
